import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const getBundlesSuggested = (params = {}) => axios.get(`${API_URLS.MATERIALS_BY_IDS}`, { params });
